import { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Shield, Heart, Briefcase, Sparkles, Eye } from "lucide-react";

const insuranceProducts = [
  {
    id: 1,
    name: "Seguro de Vida",
    description: "Protección financiera para tu familia cuando más lo necesitan",
    icon: <Shield className="h-8 w-8" />
  },
  {
    id: 2,
    name: "Seguro de Salud",
    description: "Atención médica de calidad cuando la necesites",
    icon: <Heart className="h-8 w-8" />
  },
  {
    id: 3,
    name: "Seguro Dental",
    description: "Cobertura para servicios dentales preventivos y tratamientos",
    icon: <Sparkles className="h-8 w-8" />
  },
  {
    id: 4,
    name: "Seguro de Visión",
    description: "Protección para el cuidado de tus ojos y gastos ópticos",
    icon: <Eye className="h-8 w-8" />
  },
  {
    id: 5,
    name: "Seguro Suplementario",
    description: "Cobertura adicional para complementar tu seguro principal",
    icon: <Briefcase className="h-8 w-8" />
  }
];

const InsuranceCarousel = () => {
  const [api, setApi] = useState<any>(null);

  // Auto-rotate carousel every 3 seconds
  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);

    return () => clearInterval(interval);
  }, [api]);

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-[#075985] to-[#0c4a6e] relative">
      <div className="absolute inset-0 bg-grid-white/[0.03] bg-[size:30px_30px] pointer-events-none"></div>
      <div className="absolute top-1/3 -left-20 w-64 h-64 bg-[#0EA5E9]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/3 -right-20 w-64 h-64 bg-[#0EA5E9]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <span className="px-3 py-1 rounded-full bg-white/10 text-sm font-medium mb-4 inline-block text-white shadow-sm backdrop-blur-sm">
            NUESTROS PRODUCTOS
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-medium mb-4 text-white">
            Seguros para Cada Etapa de tu Vida
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Ofrecemos una amplia gama de productos diseñados para proteger lo que más te importa.
          </p>
        </div>
        
        <div className="mt-12">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            setApi={setApi}
            className="w-full"
          >
            <CarouselContent>
              {insuranceProducts.map((product) => (
                <CarouselItem key={product.id} className="md:basis-1/2 lg:basis-1/3 pl-4">
                  <div className="bg-white/10 backdrop-blur-md rounded-lg overflow-hidden shadow-lg border border-white/10 h-full p-8 hover:bg-white/20 transition-all">
                    <div className="h-16 w-16 rounded-lg bg-gradient-to-br from-[#0EA5E9] to-[#33C3F0] flex items-center justify-center mb-6 shadow-md">
                      <div className="text-white">
                        {product.icon}
                      </div>
                    </div>
                    <h3 className="text-xl font-medium mb-3 text-white">{product.name}</h3>
                    <p className="text-white/80">{product.description}</p>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-center mt-8 gap-4">
              <CarouselPrevious className="relative static left-0 right-0 translate-y-0 bg-white/10 text-white border-white/20 hover:bg-white/20" />
              <CarouselNext className="relative static left-0 right-0 translate-y-0 bg-white/10 text-white border-white/20 hover:bg-white/20" />
            </div>
          </Carousel>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-white transform skew-y-2 origin-left"></div>
    </section>
  );
};

export default InsuranceCarousel;
